// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"iJ","contentFrame":"iK","buttonGroup":"iL","button":"iM","header":"iN","text":"iO","contentImage":"iP","closeButton":"iQ"};